import React from 'react';
import { useNavigate } from "../../hooks/useRouter";
import { useConstants } from '../../constant/constantProvider';
import './AccessDeniedModal.css';

const AccessDeniedModal = ({ appName, fallbackRoute }) => {
  const navigate = useNavigate();
  const {
    ACCESS_DENIED,
    NO_ACCESS_TO_APP,
    ASK_ADMINISTRATOR,
    OK,
  } = useConstants();

  const handleOk = () => {
    if (fallbackRoute) {
      navigate(fallbackRoute);
    }
  };

  return (
    <div className="access-denied-container">
      <div className="access-denied-card">
        <h1 className="access-denied-title">{ACCESS_DENIED}</h1>

        <p className="access-denied-message">
          {NO_ACCESS_TO_APP} <strong>{appName}</strong>!
        </p>

        {!fallbackRoute && (
          <p className="access-denied-submessage">
            {ASK_ADMINISTRATOR}
          </p>
        )}

        <div className="access-denied-actions">
          <button
            className="button-style primary-button access-denied-ok-btn"
            onClick={handleOk}
            disabled={!fallbackRoute}
          >
            {OK}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
